import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${API_URLS.VEHICLE}/v1/vehiclecategory`;
const basePath = API_URLS.VEHICLE_V3;


async function create(payload) {
  try {
    let response = await api.post(`${basePath}/categories`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "categoryService.create"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "categoryService.create");
    return null;
  }
}

async function update(payload) {
  try {
    let response = await api.put(`${basePath}/categories/${payload.categoryId}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "categoryService.update"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "categoryService.update");
    return null;
  }
}

async function list() {
  
  try {
    let response = await api.get(`${basePath}/categories`);
    let treated = errorHandling.handleResponse(
      response,
      "categoryService.list"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "categoryService.list");
    return null;
  }
}

export const categoryService = {
  create,
  update,
  list,
};
